var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "drawer-info d-flex",
      class: {
        "drawer-info--opened": _vm.shouldShowVideoList
      },
      attrs: { "data-ui-section": "drawer-info" }
    },
    [
      _c(
        "div",
        {
          staticClass:
            "\n      drawer-info__child\n      text-white m-4 w-100\n    "
        },
        [
          _c(
            "DrawerInfoHead",
            _vm._g(
              {
                staticClass: "mb-3",
                attrs: {
                  type: _vm.type,
                  author: _vm.author,
                  "public-url": _vm.publicUrl
                }
              },
              _vm.$listeners
            )
          ),
          _vm._v(" "),
          _c("DrawerInfoContent", { attrs: { title: _vm.title } })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "\n      drawer-info__action\n      d-flex d-md-none justify-content-center align-items-center p-4\n    ",
          on: {
            click: function($event) {
              _vm.shouldShowVideoList = !_vm.shouldShowVideoList
            }
          }
        },
        [
          _c("i", {
            staticClass: "material-icons",
            attrs: {
              "data-icon": _vm.shouldShowVideoList
                ? "keyboard_arrow_up"
                : "keyboard_arrow_down"
            }
          })
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }